import workspaceQuery from '../../queries/sales/TradeCounterReconcileWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/TradeCounterReconcileQuery.graphql';
import mutationQuery from '../../../graphql/mutations/sales/TradeCounterReconcileMutation.graphql';
import fragment from '../../../graphql/fragments/sales/TradeCounterReconcileFragment.graphql';
import { ALLOW_DELETE, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

export enum ITradeCounterTerminalAction {
  Reconcile = 'SALES_TRADE_COUNTER_RECONCILE_UPDATE',
}

const TradeCounterReconcile: EntityType<ITradeCounterTerminalAction> = {
  type: 'TradeCounterReconcile',
  title: 'Trade Counter Reconciliation',
  formTitle: 'Trade Counter Reconcile',
  formUrl: '/Sales/TradeCounterReconcile/Details/',
  workspaceUrl: '/Sales/TradeCounterReconcile/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'SALES_TRADE_COUNTER_RECONCILE',
  operations: ALLOW_VIEW | ALLOW_EDIT | ALLOW_DELETE,
  readOnlyStatus: [
    {
      key: 'draft',
      status: [false],
    },
  ],
  actions: [{ actionReference: ITradeCounterTerminalAction.Reconcile }],
};

export default TradeCounterReconcile;
